import { SET_MEGA_MENU_ACTIVE_LEVEL } from 'redux/modules/page/actions/types';

export const setMegaMenuActiveLevel = level => ({
  type: SET_MEGA_MENU_ACTIVE_LEVEL,
  level,
});
